import React from "react";
import {Link} from "react-router-dom";
import WLogo from "../assets/QRscriptsLogo.png";

const PrivacyPolicy = () => {
    return (
        <div className="w-full bg-white text-gray-900 min-h-screen">
            {/* ================= HEADER ================= */}
            <header className="w-full border-b bg-[#f6e9e4]">
                <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
                    <img src={WLogo} className="h-8" alt="QR Scripts" />

                    <nav className="hidden md:flex gap-6 text-sm font-medium text-gray-700">
                        <Link to="/">Home</Link>
                        <Link to="/privacypolicy">Privacy Policy</Link>
                        <Link to="/terms">Terms & Conditions</Link>
                    </nav>
                </div>
            </header>

            {/* ================= CONTENT ================= */}
            <section className="max-w-5xl mx-auto px-6 py-16">
                <h1 className="text-3xl md:text-4xl font-extrabold text-pink-600 mb-2">Privacy Policy – QR Scripts</h1>

                <p className="text-sm text-gray-500 mb-10">
                    Effective Date: December 15, 2025 | Last Updated: December 15, 2025
                </p>

                <div className="space-y-10 text-sm leading-relaxed text-gray-700">
                    {/* 1 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">1. Introduction</h2>
                        <p>
                            Hourglass Essentials Pvt Ltd operates QR Scripts and related services. This Privacy Policy
                            explains how we collect, use, store, and protect your personal information when you use our
                            QR products, website, or applications.
                        </p>
                    </section>

                    {/* 2 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">2. Information We Collect</h2>

                        <h3 className="font-semibold mt-4">2.1 Registration Information</h3>
                        <ul className="list-disc ml-6 mt-2">
                            <li>Full name</li>
                            <li>Email address</li>
                            <li>Phone number (optional)</li>
                            <li>QR code identifier</li>
                            <li>Associated URL or action</li>
                        </ul>

                        <h3 className="font-semibold mt-4">2.2 Automatically Collected Data</h3>
                        <ul className="list-disc ml-6 mt-2">
                            <li>QR scan timestamps</li>
                            <li>IP address</li>
                            <li>Device and browser information</li>
                            <li>Approximate location</li>
                        </ul>

                        <h3 className="font-semibold mt-4">2.3 Cookies</h3>
                        <p>
                            We may use cookies or similar technologies to improve performance and analyze usage
                            patterns.
                        </p>
                    </section>

                    {/* 3 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">3. How We Use Your Information</h2>
                        <ul className="list-disc ml-6">
                            <li>Enable programmable QR functionality</li>
                            <li>Redirect scans to configured actions</li>
                            <li>Communicate with registered owners</li>
                            <li>Provide customer support</li>
                            <li>Improve product performance</li>
                            <li>Comply with legal obligations</li>
                        </ul>
                    </section>

                    {/* 4 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">4. Information Sharing</h2>
                        <p>We do not sell your personal data. Information may be shared only:</p>
                        <ul className="list-disc ml-6 mt-2">
                            <li>With service providers supporting operations</li>
                            <li>To comply with legal requirements</li>
                            <li>During business restructuring or transfer</li>
                        </ul>
                    </section>

                    {/* 5 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">5. Data Retention</h2>
                        <p>
                            We retain personal data only as long as necessary for service delivery, legal compliance,
                            and legitimate business purposes.
                        </p>
                    </section>

                    {/* 6 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">6. Your Rights</h2>
                        <ul className="list-disc ml-6">
                            <li>Access and review your data</li>
                            <li>Request correction or updates</li>
                            <li>Request deletion of data</li>
                            <li>Withdraw consent where applicable</li>
                        </ul>
                        <p className="mt-2">
                            Contact us at <span className="font-medium">itadmin@companystore.io</span>
                        </p>
                    </section>

                    {/* 7 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">7. Data Security</h2>
                        <p>
                            We implement technical and organizational measures such as encryption, access controls, and
                            monitoring. No system is completely secure.
                        </p>
                    </section>

                    {/* 8 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">8. Children’s Privacy</h2>
                        <p>
                            QR Scripts is not intended for individuals under 18 years of age. We do not knowingly
                            collect data from children.
                        </p>
                    </section>

                    {/* 9 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">9. International Data Transfers</h2>
                        <p>
                            Your information may be processed outside your country of residence with appropriate
                            safeguards in place.
                        </p>
                    </section>

                    {/* 10 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">10. Policy Updates</h2>
                        <p>
                            We may update this policy periodically. Significant changes will be communicated via email
                            or platform notice.
                        </p>
                    </section>

                    {/* 11 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">11. Contact & Grievance Officer</h2>
                        <p className="font-medium">Hourglass Essentials Pvt Ltd</p>
                        <p>
                            #39 Krishna Reddy Colony, Domlur Layout,
                            <br />
                            Bangalore – 560071, India
                        </p>
                        <p>Email: itadmin@companystore.io</p>
                        <p className="mt-2">
                            <b>Grievance Officer:</b>
                            <br />
                            R Roger Daniel Fernando, IT Solutions Manager
                            <br />
                            Response time: 30 days
                        </p>
                    </section>

                    <p className="text-xs text-gray-500">
                        Document Version 1.0 | Governing Law: India | Jurisdiction: Bangalore
                    </p>
                </div>
            </section>

            {/* ================= FOOTER ================= */}
            <footer className="bg-gray-100 py-10">
                <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between text-sm text-gray-600">
                    <div>© {new Date().getFullYear()} QR Scripts</div>
                    <div className="flex gap-6">
                        <Link to="/privacypolicy">Privacy Policy</Link>
                        <Link to="/terms">Terms & Conditions</Link>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default PrivacyPolicy;
